import { DnmRequestFailure } from '../../api/dnmFailure';
import type { ShipmentStatus } from '../../api/types';

/** Partner offer price (#288, rhino-api R36, Contract dnm-work#30): reason 1–500 characters after trimming. */
export const PARTNER_PRICE_REASON_MAX = 500;

/** Whole rupees, at least ₹1. */
export function partnerPriceAmountValid(value: string): boolean {
  if (value.trim() === '') return false;
  const n = Number(value);
  return Number.isInteger(n) && n >= 1;
}

export function partnerPriceReasonValid(reason: string): boolean {
  const t = reason.trim();
  return t.length >= 1 && t.length <= PARTNER_PRICE_REASON_MAX;
}

/** Ops may set, change or clear the partner price only while the order is open for bids. */
export function partnerPriceEditable(status: ShipmentStatus): boolean {
  return status === 'DRAFT' || status === 'POSTED';
}

/** A refusal no retry can fix: the dialog refetches the order and offers Close instead of Try again. */
export function partnerPriceLocked(error: unknown): boolean {
  return error instanceof DnmRequestFailure && error.code === 'NOT_OPEN_FOR_BIDS';
}

/** Plain words + next step (UX 3). The API's free-text `error` is never shown. */
export function partnerPriceErrorMessage(error: unknown): string {
  if (error instanceof DnmRequestFailure) {
    if (error.code === 'NOT_OPEN_FOR_BIDS') {
      return "This order is no longer open for bids, so the partner price can't change. Refresh to see its current status.";
    }
    return error.message;
  }
  return 'Something went wrong. Try again.';
}
